class NSSRecommendations extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
    this.formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Recommendations] Connected.");
    this.initRecommendations();
  }

  initCarousel() {
    const carouselEl = this.querySelector(`.swiper`);
    // Cart layout (nss_cart_style modifier) puts the nav arrows in the
    // heading row, outside `.swiper`; the default (e.g. PDP) layout keeps
    // them below the cards, inside `.swiper`, alongside the pagination dots.
    // Swiper's string selectors only search within the swiper container, so
    // pass element references instead — those work regardless of position.
    const prevEl = this.querySelector(`.nss-recommendations-prev`);
    const nextEl = this.querySelector(`.nss-recommendations-next`);

    this.swiper = new Swiper(carouselEl, {
      autoHeight: false,
      grabCursor: true,
      slidesPerView: "auto",
      spaceBetween: 15,
      centeredSlides: false,
      // loop: true,

      a11y: {
        enabled: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },

      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        768: {
          spaceBetween: 40,
        },
      },
    });
  }

  initRecommendations() {
    // Static mode (e.g. empty-cart fallback products): markup is already
    // server-rendered, no data-url to fetch — just wire up the carousel.
    if (!this.dataset.url) {
      if (this.querySelector(`.swiper`)) this.initCarousel();
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const url = this.dataset.url;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("nss-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            if (recommendations.querySelectorAll(".swiper-slide").length < 1) {
              this.style.display = "none";
            }
            this.initCarousel();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 0px 0px",
    });
    observer.observe(this);
  }
}

let elementName = `nss-recommendations`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSRecommendations);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
